namespace RedBullMOBILE360.LoanWhitelist {
    export interface LoanWhitelistImportForm {
        FileName: Serenity.ImageUploadEditor;
    }

    export class LoanWhitelistImportForm extends Serenity.PrefixedContext {
        static formKey = 'LoanWhitelist.LoanWhitelistImport';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LoanWhitelistImportForm.init)  {
                LoanWhitelistImportForm.init = true;

                var s = Serenity;
                var w0 = s.ImageUploadEditor;

                Q.initFormType(LoanWhitelistImportForm, [
                    'FileName', w0
                ]);
            }
        }
    }
}
